/* eslint-disable */
export default {
  noRecords: 'Aucun enregistrement récent trouvé.',
  inBound: 'Entrant',
  outBound: 'Sortant',
  missed: 'Appel manqué',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
